export default {
	name: 'Card',
    props: {
        close: {
            type: Function,
            required: false
        }
    }
}
